export const API_BASE_URL = "https://api.memorydoodle.com/api/v1/";
export const SOCKET_URL = "https://api.memorydoodle.com";